import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';

// Importamos los componentes
import LandingPage from './components/LandingPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookieConsent from './components/CookieConsent';
import { useLandingSettings } from './hooks/useLandingSettings';

const App: React.FC = () => {
  const { settings } = useLandingSettings();

  return (
    <Router>
      <div className="font-sans bg-gray-50">
        {/* WhatsApp flotante */}
        <a
          href={`https://wa.me/${settings.whatsapp}`}
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-6 right-6 bg-green-500 text-white p-4 rounded-full shadow-lg z-50 hover:bg-green-600 transition-all duration-300"
        >
          <FaWhatsapp size={24} />
        </a>

        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>

        {/* Banner de Cookies */}
        <CookieConsent />
      </div>
    </Router>
  );
};

export default App;